import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";
import { Button, Typography } from "@material-ui/core";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import {
	Row,
	Col,
} from "reactstrap";

// import Alert from "@material-ui/lab/Alert";

const JobAd = (props) => {
	return (
		<Alert color="">
		<h3 className="text-center">
				<b> Job Openings! </b>
		</h3>
		<br />
			<h5 className="text-center">
				City@UMD is looking for an Assistant Research Faculty with programming
				experience.
			</h5>
			<br />
			<div className="alert-actions" className="text-center">
				<Button
					color="secondary"
					variant="outlined"
					style={{width: "100%", height: "35px"}}
					href={`${process.env.PUBLIC_URL}/uploads/City@UMD Programming_IT Job Posting.pdf`}
					target="_blank"
				>
					Read Job Description
				</Button>
					<br /><br />
				<Button
					style={{width: "100%", height: "35px"}}
					color="secondary"
					variant="outlined"
					href="mailto:szhu918@umd.edu"
					target="_blank"
				>
					Contact Dr. Shengwei Zhu to Apply
				</Button>
			</div>
		</Alert>
	);
};

// https://docs.google.com/spreadsheets/d/e/2PACX-1vQ0-esrxucyus6sBMF9SyAfrBc-DUaOWHa85VxuC--Jun3AVj6PysWt8kLu00pR1GK11bsmLGso9uJo/pubhtml?gid=0&single=true
let id = "1XFDAKwEIu5ETKQo8g4tFIBnwPof77f6BkKaOaYlQCpw";
let api = `https://sheets.googleapis.com/v4/spreadsheets/${id}/values:batchGet?ranges=Sheet1&majorDimension=ROWS&key=${process.env.REACT_APP_GOOGLE_API}`;
function Jobs() {
	useEffect(() => {
		console.log({ id, key: process.env.REACT_APP_GOOGLE_API });
		fetch(api)
			.then((response) => response.json())
			.then((data) => console.log(data))
			.catch((err) => console.error(err));
	}, []);
	return (
		<div className="container-fluid" style={{ paddingTop:16 }}>
			<div className="column">
				<div className="col-md-10 offset-md-1 col-sm-8 offset-sm-2 col-12">
						<h1 className="text-center"> <u> Jobs! </u> </h1>
							<Alert color="">
								<h4>
								City@UMD is connected via colleagues, collaborators, and alumni to
								numerous institutions, companies and research labs. This jobs portal
								is provided to showcase jobs available within City@UMD and at
								other institutions. Check back periodically for updated information
								and new job postings.
								</h4>
							</Alert>
				</div>


		<Col xs="12" sm={{ size: 10, offset: 1 }}>
			<Row>
				<Col xs="12" sm={{ size: 8, offset: 0 }}>
				<div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1 col-12">
					<h2 className="text-center">
						Apply for a position within City@UMD
					</h2>
					<h5 className='text-center'> Come join our team! </h5>
					<br />
					<div>
							<Button
								color="primary"
								variant="outlined"
								component={Link}
								style={{width: "100%", left: "0%"}}
								to={"/jobs/application?position=undergrad"}
								size="large"
							>
								As an Undergraduate Student Researcher
							</Button>
							<br /><br />
							<Button
								color="primary"
								variant="outlined"
								component={Link}
								style={{width: "100%", left: "0%"}}
								to={"/jobs/application?position=graduate"}
								size="large"
							>
								As a Graduate Student Researcher
							</Button>
							<br /><br />
							<Button
								color="primary"
								variant="outlined"
								component={Link}
								style={{width: "100%", left: "0%"}}
								to={"/jobs/application?position=associate"}
								size="large"
							>
								As a Post-Doc or Research Faculty
							</Button>
					</div>
				</div>
				</Col>
				<Col xs="12" sm={{ size: 4, offset: 0 }}>
						<JobAd></JobAd>
				</Col>
			</Row>
		</Col>

		<h1 className="text-center">
			 <u> Job Advertising Board </u>
		</h1>
	<br />
		<div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1 col-12">
			<h6 className="text-center">
				The table below lists of several openings at a range of companies and organizations.
				A description of each listing is provided detailing what the position requires and entails.
				If you are interested in any of the opportunities, make sure to reach out to the company
				using the information provided in the Contact or Apply links!
			</h6>
		</div>
		<br />
			<Button
					variant="outlined"
					color="primary"
					href="https://forms.gle/t1mDhc6Ktc6aTM7Q6"
					style={{ width: "50%", left: "25%"}}
								>
				Submit a Job for Advertisment
			</Button>

				<div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1 col-12">
					<div style={{ display: "flex", margin: 8 }}>
						<iframe
							title="Jobs Spreadsheet"
							width="1170px" // width will need to be increased if more columns are added but that would impact the general formatting
							height="500px" //if more jobs are added the job page height needs to be manually increased
							style={{ margin: "auto" }}
							src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQ0-esrxucyus6sBMF9SyAfrBc-DUaOWHa85VxuC--Jun3AVj6PysWt8kLu00pR1GK11bsmLGso9uJo/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"
						></iframe>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Jobs;
